(function ($) {

    function calculateLoan() {
        const price = $('.range-slider[data-type="price"] input').val();
        const depositPercentage = $('.range-slider[data-type="deposit"] input').val();
        const depositAmount = price * depositPercentage * 0.01;
        const interestRate = $('.range-slider[data-type="interest"] input').val();
        const loanPeriod = $('.loan-period input:checked').val() * 12;
        const loan = price * (1-(depositPercentage/100));
        const r = interestRate/100/12;
        const monthlyPayment = loan * r * (Math.pow(1+r, loanPeriod)) / (Math.pow(1+r,loanPeriod)-1);
        $('.result-block h2').html(numberWithCommas(monthlyPayment.toFixed(2))+' €');
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    $(".loan-modal .range-slider").each(function (index, el) {
        $(el).find('.js-range-slider').ionRangeSlider({
            onStart: function (data) {
                $(el).find('.value-output').text(data.from_pretty + $(el).data('symbol'));
            },
            onChange: function (data) {
                $(el).find('.value-output').text(data.from_pretty + $(el).data('symbol'));
                calculateLoan();

                if ($(el).data('type') === "deposit" || $(el).data('type') === "price") {
                    const price = $('.range-slider[data-type="price"] input').val();
                    const deposit = $('.range-slider[data-type="deposit"] input').val();
                    const calculatedDeposit = (price * deposit * 0.01).toLocaleString().replace(/,/g, " ")

                    $('.range-slider[data-type="deposit"] .calculated-deposit').text(calculatedDeposit + " €")
                }
            }
        });


        let rangeSlider = $(el).find('.js-range-slider').data("ionRangeSlider");
    });

    $('.loan-period-selection input').each(function (){
        $(this).on('click', function (){
            calculateLoan();
        })
    });

    $('.loan-modal-block .loan-modal-trigger, [data-loan-modal]').on('click', function () {

        // Open modal and hide body overflow
        //
        $('.loan-modal').addClass('active');
        $('body').addClass('overflow-hidden');

        // Get data inputs
        //
        var dataInputElement = $('.c-header-price__sum-regular.is-active');

        // Set range new values
        //
        $('.range-slider[data-type="price"] input').val($(dataInputElement).data("full-price") );

        let apartment_price_min = $(dataInputElement).data("full-price") - 100000;
        let apartment_price_max = $(dataInputElement).data("full-price") + 100000;
        if( apartment_price_min < 150000 ) {
            apartment_price_min = 150000;
        }
        $('.range-value-from').html(numberWithCommas(apartment_price_min)+ " €");
        $('.range-value-to').html(numberWithCommas(apartment_price_max)+ " €");
        $('.range-slider[data-type=price] .value-output').html(numberWithCommas($(dataInputElement).data("full-price"))+ " €");

        calculateLoan();
    });

    $('.loan-modal .close-button').on('click', function (){
        $('.loan-modal').removeClass('active');
        $('body').removeClass('overflow-hidden');
    });

})(jQuery);
